import type { DashboardScopeSearch } from "./dashboard-app";

export function validateDashboardSearch(input: Record<string, unknown>): DashboardScopeSearch {
  return {
    company: typeof input.company === "string" && input.company ? input.company : undefined,
    entity: typeof input.entity === "string" && input.entity ? input.entity : undefined,
    location: typeof input.location === "string" && input.location ? input.location : undefined,
    from: typeof input.from === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input.from) ? input.from : undefined,
    through: typeof input.through === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input.through) ? input.through : undefined,
    quickbooks: input.quickbooks === "failed" || input.quickbooks === "denied" || input.quickbooks === "connected"
      ? input.quickbooks
      : undefined,
  };
}
